export const layout = {
  namespaced: true,
  state: {
    drawer: true,
    title: "",
    overlay: { value: false, title: "" },

    // Snackbar global
    snackbar: {
      show: false,
      text: "",
      color: "error",
      timeout: 4000,
    },
  },

  getters: {
    DRAWER_VALUE(state) {
      return state.drawer;
    },
    TITLE_VALUE(state) {
      return state.title;
    },
    OVERLAY_VALUE(state) {
      return state.overlay;
    },

    // Getter Snackbar
    GET_SNACKBAR(state) {
      return state.snackbar;
    },
  },

  mutations: {
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_TITLE(state, payload) {
      state.title = payload;
    },
    SET_OVERLAY(state, payload) {
      state.overlay = payload;
    },
    CLEAR_TITLE(state) {
      state.title = "";
    },

    // Mostrar Snackbar
    SHOW_SNACKBAR(state, payload) {
      state.snackbar = {
        show: true,
        text: payload.text || "",
        color: payload.color || "error",
        timeout: payload.timeout || 4000,
      };
    },

    // Ocultar Snackbar
    HIDE_SNACKBAR(state) {
      state.snackbar.show = false;
    },
  },

  actions: {},
};